import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"search\">\n  <path fill-rule=\"evenodd\" d=\"M382.217,267.717a1,1,0,0,1-1.414,0l-3.15-3.15a7,7,0,1,1,1.415-1.414l3.149,3.15A1,1,0,0,1,382.217,267.717Zm-5.2-12.271a5,5,0,1,0,0,7.071A5,5,0,0,0,377.017,255.446Z\" transform=\"translate(-366.5 -252)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/search.svg
// module id = null
// module chunks = 